module.exports = __webpack_public_path__ + "img/bg.8ed2dd24.jpg";